import Vue from "vue";
import { Component } from "vue-property-decorator";
import { validations, validationMessages } from "./validations";
import { IUser } from "@/models";
import { Validation } from "vuelidate";
import * as icons from "@/components/icons";
@Component({
    name: "users",
    validations,
    components: {
        "add-icon": icons.AddIcon,
        "delete-icon": icons.DeleteIcon,
    },
})
export default class Users extends Vue {

    public promises: Array<Promise<any>>;
    public userVIPName: string;
    public userAdminName: string;

    constructor() {
        super();

        this.promises = [];
        this.userVIPName = "";
        this.userAdminName = "";

        if (!this.$store.state.app.adminUsers) {
            this.promises.push(this.$store.dispatch("app/fetchAdminUsers"));
        }

        if (!this.$store.state.app.vipUsers) {
            this.promises.push(this.$store.dispatch("app/fetchVipUsers"));
        }
    }

    public get adminUsers(): IUser[] {
        return this.$store.getters["app/getAdmins"];
    }

    public get vipUsers(): IUser[] {
        return this.$store.getters["app/getVips"];
    }

    public get validationMessages(): { [key: string]: string } {
        return validationMessages;
    }

    public async addAdmin(): Promise<void> {
        if (this.validateBeforeSave(this.$v.userAdminName)) {
            await this.$store.dispatch("app/addAdminUser", {
                userEmail: this.userAdminName,
                userRole: "Admin",
            });
            this.userAdminName = "";
            this.$v.userAdminName.$reset();
        }
    }

    public async addVIP(): Promise<void> {
        if (this.validateBeforeSave(this.$v.userVIPName)) {
            await this.$store.dispatch("app/addVipUser", {
                userEmail: this.userVIPName,
                userRole: "Vip",
            });
            this.userVIPName = "";
            this.$v.userVIPName.$reset();
        }
    }

    public async deleteUser(user: IUser): Promise<void> {
        await this.$store.dispatch("app/deleteUser", user.userInfoId);
    }

    public validateBeforeSave(rules: Validation): boolean {
        rules.$touch();
        return !rules.$invalid;
    }
}
